import { error } from "../components/common/global";

//export const catchError = (fn) => (fail) => (...args) => {
export const catchError = async fn => {
    return fn().catch(ex => {
        error(ex.message, ex); // TODO: the persist prop needs to be passed here.
    });
};